import React from 'react';
import styled from 'styled-components';
import {
  black,
  blue,
  gray,
  green,
  red,
  orange,
  purple,
  lightGray,
  white,
  whitesmoke,
  darkGray,
} from 'utils/style/colors';

export interface IBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode | string;
  color?: Colors;
  hollow?: boolean;
  radius?: number;
  size?: number;
  textColor?: Colors;
  clickable?: boolean;
}

export type Colors =
  | 'blue'
  | 'red'
  | 'gray'
  | 'lightGray'
  | 'whitesmoke'
  | 'green'
  | 'black'
  | 'orange'
  | 'white'
  | 'purple'
  | string;

const setColor = {
  red,
  blue,
  gray,
  darkGray,
  lightGray,
  whitesmoke,
  black,
  green,
  orange,
  white,
  purple,
};

export const Span = styled('span')<IBadgeProps>`
  display: inline-flex;
  align-items: center;
  color: ${(props) =>
    props.hollow
      ? props.textColor
        ? setColor[props.textColor] || props.textColor
        : props.color
          ? setColor[props.color] || props.color
          : blue
      : props.textColor
        ? setColor[props.textColor] || props.textColor
        : 'var(--exact-white)'};
  width: ${(props) => (props.size ? `${props.size}em` : '')};
  padding: 5px 10px;
  font-size: 10px;
  text-align: center;
  font-weight: 400;
  line-height: 1.3;
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'auto')};
  border-radius: ${(props) => (props.radius ? `${props.radius}px` : '15px')};
  border: ${(props) =>
    props.hollow
      ? `1px solid ${props.color ? setColor[props.color] || props.color : blue}`
      : undefined};
  background-color: ${(props) =>
    props.hollow
      ? 'transparent'
      : props.color
        ? setColor[props.color] || props.color
        : blue};
  @media (max-width: 400px) {
    padding: 5px;
  }
`;

const Badge: React.FC<IBadgeProps> = ({ children, onClick, ...restProps }) => {
  return (
    <Span clickable={!!onClick} {...restProps} onClick={onClick}>
      {children}
    </Span>
  );
};

export default React.memo(Badge);
